<div class="marv_circle"
    [class.small]="this.sizeCircle === 'small'"
    [class.primary]="this.colorCircle === 'primary'"
    [class.secondary]="this.colorCircle === 'secondary'"
    [class.blue]="this.colorCircle === 'blue'"
    [class.red]="this.colorCircle === 'red'"
    [class.green]="this.colorCircle === 'green'"
    [class.orange]="this.colorCircle === 'orange'"
    [class.purple]="this.colorCircle === 'purple'"
    [class.marvesting]="this.colorCircle === 'marvesting'"     
    >
    <ng-content></ng-content>
</div>